/**
 * Created by hp on 2017/8/28.
 */
import React, {Component} from 'react';
import {Button} from 'react-weui';
import { browserHistory } from 'react-router'


class LiveroomVerifySuccess extends Component {
    handleBack() {
        const {liveroomId} = this.props;
        if (this.props.fr && this.props.fr === 'withdraw') {
            browserHistory.replace('/wallet/withdraw_apply?fr=old')
        } else {
            location.assign(`/liveroom/${liveroomId}`)
        }
    }

    render() {
        return (
            <div className="liveroom-verify-success">
                <div className="logo" style={{paddingTop: '100px'}}>
                    <img src="https://static-cos.lycheer.net/picture/6229093_46bafe82b4b0b24bae3725aecd022881.jpg"/>
                </div>

                <div className="tips">
                    <p>提交的认证信息正在审核中，请耐心等待</p>
                    <p>认证结果将会通过公众号告知</p>
                </div>
                <div className="wk-btn-90" style={{width: '60%', marginTop: '40px'}}>
                    <Button onClick={this.handleBack.bind(this)}>{this.props.fr && this.props.fr === 'withdraw' ? '返回提现页' : '返回店铺'}</Button>
                </div>
            </div>
        )
    }
}

export default LiveroomVerifySuccess;



// WEBPACK FOOTER //
// ./src/components/liveroomVerify/LiveroomVerifySuccess.js